import React from 'react';
import Reveal from '../ui/Reveal';

const AiBanner: React.FC = () => {
  return (
    <section className="relative pb-4">
      <div className="mx-auto max-w-7xl px-5">
        <Reveal className="relative overflow-hidden rounded-[26px] border border-white/10">
          <img
            src="/images/06-masterclass/masterclass-6.jpeg"
            alt="La IA potencia el conocimiento humano"
            loading="lazy"
            className="h-[220px] w-full animate-kenburns object-cover md:h-[300px]"
          />
          <div
            className="absolute inset-0"
            style={{
              background:
                'linear-gradient(90deg, rgba(7,12,36,.92) 0%, rgba(7,12,36,.6) 48%, rgba(7,12,36,.2) 100%)',
            }}
          />
          <div className="absolute inset-0 flex items-center">
            <div className="max-w-xl p-8 md:p-12">
              <p className="font-display text-2xl font-bold leading-tight md:text-3xl">
                La IA no reemplaza tu experiencia: <span className="text-gradient-mc">la potencia.</span>
              </p>
              <p className="mt-3 font-light text-white/70">Aprende a dirigirla con criterio, contexto y método.</p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default AiBanner;
